import {styled} from "@mui/material/styles";
import {useDrawingArea} from "@mui/x-charts/hooks";
import Paper from "@mui/material/Paper";
import {Box, Grid, Stack, Typography} from "@mui/material";
import {PieChart} from "@mui/x-charts/PieChart";
import React from "react";

export const TotalSms = ({allSmsData}) => {
    const getRandomColorArray = () => {
        const randomColor = () => Math.floor(Math.random() * 255); // Random number between 0 and 255
        return Array.from({ length: allSmsData.length }, () => [
            randomColor(),
            randomColor(),
            randomColor(),
        ]);
    };
    const colors = getRandomColorArray();

    const data1 = allSmsData.map((el, idx) => ({...el, color: `rgba(${colors[idx]})`, bg: `rgba(${colors[idx]}, 0.1)`}));
    const data2 = allSmsData.map((el, idx) => ({...el, color: `rgba(${colors[idx]}, 0.1)`}));
    // const xxx = data.map(({label, color, value}, id) => ({label: `${label} ${value}`, id, color}))

    const leadsCount = data1.reduce((acc, el) => acc + el.value, 0)

    function PieCenterLabel1({children}) {
        const StyledText = styled('text')(({ theme }) => ({
            fill: '#2B3033',
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 26,
            lineHeight:30,
            fontWeight:500,
        }));
        const { width, height, left, top } = useDrawingArea();
        return (
            <StyledText  textLength="auto" x={left + width / 2} y={(top + height / 2) -10}>
                {children}
            </StyledText>
        );
    }
    function PieCenterLabel2({children1, children2}) {
        const StyledText = styled('text')(({ theme }) => ({
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 26,
            lineHeight:30,
            fontWeight:500,
            letterSpacing:'0.05px'
        }));
        const { width, height, left, top } = useDrawingArea();
        return (
            <>
                <StyledText fill={'#2B3033'} textLength="auto" x={(left + width / 2)} y={(top + height / 2) + 20}>
                    {children1}
                </StyledText>
                {/*<StyledText fill={data1[1].color} textLength="auto" x={(left + width / 2) +25} y={(top + height / 2) + 10}>*/}
                {/*    {children2}*/}
                {/*</StyledText>*/}
            </>
        );
    }
    //pie chart end
    const ItemChart = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'transparent',
        ...theme.typography.body2,
        color: theme.palette.text.secondary,
        boxShadow:'none'
    }));
    return (
        <>

            <Box sx={{padding:'10px 20px'}}>

                <Box sx={{display:'flex',alignItems:'center',mb:3}}>
                    <Typography variant="div" component="div" fontSize={'28px'} fontWeight="600" width={'max-content'} mr={3} color={'#2B3033'}>
                        Total Sms
                    </Typography>
                </Box>
                <ItemChart className="claims_ratio_chart">
                    <Grid container columnSpacing={2} sx={{alignItems:'center',justifyContent:'space-between'}}>
                        <Grid item xs={6} md={7} lg={6} sx={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                            <PieChart
                                className={'jjjjjjjjjj'}
                                series={[
                                    {data: data1, innerRadius: 180,paddingAngle: 1,outerRadius: 176},
                                    {data: data2, innerRadius: 140,paddingAngle: 1}

                                ]}
                                margin={{ right: 0}}
                                width={380}
                                height={380}
                                slotProps={{
                                    legend:  {
                                        hidden:true
                                    }
                                }}
                            >
                                <PieCenterLabel1>Total Sms</PieCenterLabel1>
                                <PieCenterLabel2 children1={leadsCount} />
                            </PieChart>
                        </Grid>
                        <Grid item xs={6} md={5} lg={6} textAlign={'left'}>
                            <Box className="infoCart_scroll">
                                {/*<Box sx={{py:1}}>*/}
                                {/*    <Typography className="label_leads_state"  variant="span" component="div">*/}
                                {/*        TOTAL CALLS*/}
                                {/*    </Typography>*/}
                                {/*    <Typography className="val_leads_state"  variant="span" component="div" sx={{color:"#2B3033"}} fontWeight={600}>*/}
                                {/*        {leadsCount}*/}
                                {/*    </Typography>*/}
                                {/*</Box>*/}
                                {data1.map(el => (
                                    <Box key={el.value} sx={{py:0.5,px:1,mb:0.3,borderLeft:'3px solid',borderColor:el.color,background:el.bg,}} >
                                        <Typography className="label_leads_state" gutterBottom variant="span" component="div" textTransform={'uppercase'}>
                                            {el.label}
                                        </Typography>
                                        <Stack direction="row" spacing={5} sx={{justifyContent:'space-between'}}>
                                            <Typography className="val_leads_state" gutterBottom variant="span" component="div" sx={{textTransform:'uppercase'}}>
                                                {el.value}
                                            </Typography>
                                            <Typography className="val_leads_state" gutterBottom variant="span" component="div">
                                                {Math.round(100 * el.value / leadsCount)} %
                                            </Typography>
                                        </Stack>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>

                </ItemChart>
            </Box>

        </>
    )
}